export default __webpack_public_path__ + "static/media/replit.3c3b0ba7.png";